import { APP_STATUS } from "../types";

export function setAppStatus(status) {
  return (dispatch) => {
    dispatch(setInitialStatus(status));
  };
}

const setInitialStatus = (status) => {
  return {
    type: APP_STATUS,
    payload: status,
  };
};
